import React from 'react';
import classNames from 'classnames/bind';
import { Image } from '@thd-olt-component-react/image';
import styles from '../components/text-an-expert.module.scss';

let cx = classNames.bind(styles);

export const IOS = () => (
  <a
    className={cx('business-chat__link')}
    href="https://bcrw.apple.com/urn:biz:88d22123-779e-11e7-a907-c753b1bff6fa"
    target="_blank"
    rel="noreferrer noopener"
  >
    <div className={cx('banner')}>
      <Image
        alt="Chat Icon"
        asset="chat_expert_online.svg"
        className={cx('banner__icon')}
        height="50"
        width="50"
      />
      <div className={cx('banner__text')}>
        <span>TEXT A HOME DEPOT EXPERT</span>
      </div>
      <div className={cx('abc-icon', 'col__2-12')}>
        <div
          className="apple-business-chat-message-container"
          data-apple-icon-title="Text a Home Depot Expert"
          data-apple-business-id="88d22123-779e-11e7-a907-c753b1bff6fa"
        />
      </div>
    </div>
  </a>
);
